import React from "react";
import Profile from '../../../assets/images/profile.png';
import { format } from 'date-fns';
import Heading from '../../../components/shared/heading';

const RenewalDetails = ({ renewal, renewalId }) => {
    const getValidityDays = (start, end) => {
        if (!start || !end) return 'N/A';
        const diffMs = new Date(end) - new Date(start);
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
    };

    return (
        <div className="flex items-start gap-4">
            <div className="flex flex-col gap-1">
                {renewal ? (
                    <>
                        {/* Name & Vehicle */}
                        <Heading>
                            {renewal.name} [{renewal.vehicle}]
                        </Heading>

                        {/* Type */}
                        <p className="text-sm text-gray-600 mb-1">{renewal.type}</p>

                        {/* Vendor */}
                        <p className="text-sm text-gray-700">
                            <strong>Vendor:</strong> {renewal.vendors?.join(', ') || 'N/A'}
                        </p>

                        {/* Status */}
                        <div className="mt-2">
                            <span
                                className={`px-2 py-0.5 rounded-md border text-sm font-medium capitalize
                                ${renewal.status === "active"
                                        ? "bg-green-100 text-green-700 border-green-600"
                                        : renewal.status === "inactive"
                                            ? "bg-red-100 text-red-700 border-red-600"
                                            : "bg-yellow-100 text-yellow-700 border-yellow-500"
                                    }`}
                            >
                                ● {renewal.status}
                            </span>
                        </div>

                        {/* Due Date */}
                        <p className="text-sm text-gray-700 mt-2">
                            <strong>Due Date:</strong>{' '}
                            {renewal.dueTime ? format(new Date(renewal.dueTime), 'PPP p') : 'N/A'}
                        </p>

                        {/* Lineage ID */}
                        <p className="text-sm text-gray-700">
                            <strong>Lineage ID:</strong> {renewal.lineageId || 'N/A'}
                        </p>

                        {/* Validity (Days between renewalTime and dueTime) */}
                        <p className="text-sm text-gray-700">
                            <strong>Validity:</strong>{' '}
                            {getValidityDays(renewal.renewalTime, renewal.dueTime)}
                        </p>

                        {/* User Info */}
                        {/* <div className="flex flex-wrap font-medium gap-2 mt-4 text-sm">
                            <span className="px-2 py-1 text-gray-800">No Group</span>
                            <span className="px-2 py-1 text-blue-700 flex items-center gap-1">
                                <img
                                    src={Profile}
                                    alt="user"
                                    width={20}
                                    height={20}
                                    className="rounded-full"
                                />
                                Jacob Silva
                            </span>
                        </div> */}
                    </>
                ) : (
                    <div className="text-red-600">
                        Renewal with ID <strong>{renewalId}</strong> not found.
                    </div>
                )}
            </div>
        </div>
    );
};

export default RenewalDetails;
